import { render } from "./CollectionResurrectTokenCard.vue?vue&type=template&id=8f02e6e2"
import script from "./CollectionResurrectTokenCard.vue?vue&type=script&lang=js"
export * from "./CollectionResurrectTokenCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__